import { Users, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PRIMARY, Reveal, Kicker } from "@/components/landing/shared";

export const Offer = ({ startTeam }) => (
  <section id="offer" className="scroll-mt-20 py-16 lg:py-24">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
        <Reveal className="lg:col-span-7">
          <Kicker><Users className="h-3.5 w-3.5" /> Simple, team-first pricing</Kicker>
          <h2 className="rb-display text-3xl font-semibold tracking-tight text-[color:var(--rb-text)]">Free to try. $15/seat when you're ready.</h2>
          <p className="mt-2 max-w-2xl text-[color:var(--rb-text-dim)]">Every org starts on the Free plan &mdash; up to 5 seats, the full governance workflow, no credit card. Upgrade to Team for unlimited seats.</p>
          <div data-testid="landing-value-stack" className="mt-6 space-y-2.5">
            {[
              "Unlimited artifacts — skills, agents, commands, and configs",
              "Safety scan (heuristic + LLM) and admin approval on every submission",
              "The plugin — automatic sync to every engineer's Claude Code",
              "Full version history and an append-only audit trail",
              "Yank a bad version instantly — pulled from every engineer's next sync",
            ].map((item) => (
              <div key={item} className="flex items-center gap-3 rounded-xl border border-[color:var(--rb-border)] bg-[color:var(--rb-obsidian)] px-4 py-3">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[color:rgba(45,212,191,0.14)]"><Check className="h-3.5 w-3.5 text-[color:var(--rb-accent)]" /></span>
                <span className="flex-1 text-sm text-[color:var(--rb-text)]">{item}</span>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.08} className="lg:col-span-5">
          <div data-testid="landing-offer-price-anchor" className="sticky top-24 rounded-2xl border border-[color:rgba(212,175,55,0.3)] bg-[color:var(--rb-obsidian)] p-7 shadow-[0_0_0_1px_rgba(212,175,55,0.12),0_18px_60px_rgba(0,0,0,0.45)]">
            <div className="flex items-center justify-between">
              <span className="text-sm text-[color:var(--rb-text-dim)]">Free plan</span>
              <span className="rb-display text-xl font-semibold text-[color:var(--rb-accent)]">Up to 5 seats</span>
            </div>
            <div className="mt-3 flex items-end justify-between border-t border-[color:var(--rb-border)] pt-4">
              <span className="text-sm text-[color:var(--rb-text-dim)]">Team plan</span>
              <div className="text-right">
                <span className="rb-display text-5xl font-semibold text-[color:var(--rb-text)]">$15</span>
                <span className="ml-1 text-sm text-[color:var(--rb-text-faint)]">/seat/mo</span>
              </div>
            </div>
            <Button onClick={startTeam} data-testid="landing-offer-primary-cta" className={`mt-6 h-12 w-full rounded-xl text-base ${PRIMARY}`}>
              Start a team registry &mdash; free
            </Button>
            <p className="mt-3 text-center text-xs text-[color:var(--rb-text-faint)]">No credit card to start. Upgrade only when you outgrow 5 seats.</p>
            <div className="mt-5 space-y-2 border-t border-[color:var(--rb-border)] pt-4">
              {["No credit card for the Free plan", "Export everything, any time", "Cancel Team anytime — never lose your catalog"].map((t) => (
                <div key={t} className="flex items-center gap-2 text-sm text-[color:var(--rb-text-dim)]"><Check className="h-4 w-4 text-[color:var(--rb-accent)]" /> {t}</div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
